import { useRef } from 'react'
import getRoutes from '@/router/routes'
import AnimatedRoutes from '@/components/TransitionSwitch/AnimatedRoutes'
import RouteTransition from '@/components/TransitionSwitch/RouteTransition'

const Router = ({ routes }) => {
  const lang = useRef(window.pathSite || '')

  return (
    <div className="route-container">
      <AnimatedRoutes
        exitBeforeEnter
        initial={false}
      >
        {getRoutes(routes, lang.current)
          .map(({ key, path, exact, render, transition }) => (
            <RouteTransition
              key={key}
              path={path}
              exact={exact}
              render={render}
              transition={transition}
            />
          ))}
      </AnimatedRoutes>
    </div>
  )
}

export default Router
